<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit fee details" onOk="handleOk">
      <template slot="footer">
          <a-button key="back" @click="handleCancel">Cancel</a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Fee</a-button>
      </template>
      <a-spin :spinning="spinning">
          <a-form class="mb-4" :form="form">
            <a-form-item label="Name">
              <a-input
                  placeholder="Name"
                  v-decorator="['name', {rules: [{ required: true, message: 'Please input fee name!' }, {max: 50, message: 'Must not exceed 50 characters!'}]}]"
              />
            </a-form-item>
            <a-form-item label="Category">
              <a-select
                v-decorator="['category', {rules: [{ required: true, message: 'Please select a category!' }]}]"
                placeholder="Select category"
              >
                <a-select-option v-for="category in categories" :key="category" :value="category">
                  {{ category }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Description">
              <a-textarea
                placeholder="Description"
                v-decorator="['description', {rules: [{ required: false, message: 'Please input fee name!' }, {max: 300, message: 'Must not exceed 300 characters!'}]}]"
              />
            </a-form-item>
            <a-form-item
              label="Type"
            >
              <a-radio-group
                v-decorator="[
                  'type',
                  {rules: [{ required: true, message: 'Please select a type!' }],
                  initialValue: 1 },
                ]"
              >
                <a-radio v-for="feeType in feeTypes" :value="feeType.value" :key="feeType.value" class="mr-2">
                  <span class="text-bold">{{feeType.name}}</span>
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <div class="row mb-0">
              <div class="col-md-4 mb-2">
                <a-form-item label="Fine Mode">
                  <a-select style="width:150px" v-model="fine_mode"
                            placeholder="Select fine mode">
                    <a-select-option value="0">Select fine mode</a-select-option>
                    <a-select-option value="1">Fixed</a-select-option>
                    <a-select-option value="2">Daily Increment</a-select-option>
                    <a-select-option value="3">Weekly Increment</a-select-option>
                    <a-select-option value="4">Monthly Increment</a-select-option>
                    <a-select-option value="5">Quarterly Increment</a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="col-md-4 mb-2">
                <a-form-item label="Fine Type">
                  <a-select style="width:150px" v-model="fine_type">
                    <a-select-option value='1'>Amount</a-select-option>
                    <a-select-option value='2'>Percentage</a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="col-md-4 mb-2" v-if="fine_type === '1'">
                <a-form-item class="mb-0" label="Fine Amount">
                  <div style="width:120px;">
                    <a-input-number
                      placeholder="Fine amount"
                      v-decorator="[`fine`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                      :initialValue="0"
                      :min="0"
                      :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                      style="width:100%;"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-4 mb-2" v-if="fine_type === '2'">
                <a-form-item class="mb-0" label="Fine %">
                  <div style="width:120px;">
                    <a-input-number
                      placeholder="Fine %"
                      v-decorator="[`fine`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                      :initialValue="0"
                      :min="0"
                      :max="100"
                      :formatter="value => `${value}%`"
                      :parser="value => value.replace(/\%\s?|(,*)/g, '')"
                      style="width:100%;"
                    />
                  </div>
                </a-form-item>
              </div>
            </div>
          </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { pick, mapValues } from 'lodash'
import { feeTypes } from '@/services/globaldata'

export default {
  name: 'EditFee',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      feeId: null,
      feeTypes,
      categories: [],
      fine_mode: '0', // 1: Fixed,  2: Daily Increment 3: Weekly Increment
      fine_type: '1', // 1: Amount, 2: Percentage
    }
  },
  mounted: function () {
    this.$eventBus.$on('openFeeEditModal', this.showModal)
  },
  methods: {
    getFeeCategories() {
      return this.$http.get('/api/fee/categories')
    },
    showModal: function(feeId) {
      this.feeId = feeId
      this.visible = true
      this.spinning = true

      const getCategories = this.getFeeCategories()
      const getFee = this.$http.get('/api/fee/' + feeId)

      Promise.all([getCategories, getFee]).then(([categoriesResponse, feeResponse]) => {
        this.categories = categoriesResponse.data.data

        const editData = pick({ ...feeResponse.data.data }, ['name', 'description', 'type', 'fine_type', 'fine_mode', 'fine', 'category'])
        const fieldsData = mapValues({ ...editData }, function(value) {
          return value !== null ? value : null
        })
        this.fine_mode = fieldsData.fine_mode === null ? '0' : fieldsData.fine_mode.toString()
        this.fine_type = fieldsData.fine_type === null ? null : fieldsData.fine_type.toString()

        this.$nextTick(() => {
          this.form.setFieldsValue(fieldsData)
        })

        this.spinning = false
      }).catch(error => {
        this.spinning = false
        this.$neoNotify.error(error)
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/fee/' + this.feeId, {
                  name: values.name,
                  description: values.description,
                  type: values.type,
                  fine_mode: this.fine_mode,
                  fine_type: this.fine_type,
                  fine: values.fine,
                  category: values.category,
                })
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated',
                    description: `Fee ${data.data.name} updated successfully!`,
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
